import styled from 'styled-components'
import { mq } from '../../../styles/vars/media-queries.style'

export const HomeCompareMain = styled.div`
  ${mq.tabletLMax} {
    padding-bottom: 10rem;
  }
`
